function t(e) {
    for (var t = e + "=", o = decodeURIComponent(document.cookie).split(";"), n = 0; n < o.length; n += 1) {
        for (var r = o[n]; " " === r.charAt(0); ) r = r.substring(1);
        if (0 === r.indexOf(t)) return r.substring(t.length, r.length);
    }
    return "";
}
window.getCookie = t;
window.setCookie = function (key, value, options = {}) {
    options = options || {};
    let cookieString = encodeURIComponent(key) + "=" + encodeURIComponent(value || "");

    // Handle expiration: accepts either {expires: days} or numeric value for backward compatibility
    let expires = options.expires ?? (typeof options === "number" ? options : undefined);
    if (typeof expires === "number") {
        let date = new Date();
        date.setTime(date.getTime() + (expires * 24 * 60 * 60 * 1000));
        cookieString += "; expires=" + date.toUTCString();
    }

    // Handle secure flag
    if (options.secure) {
        cookieString += "; Secure";
    }

    // Handle path
    if (options.path) {
        cookieString += "; path=" + options.path;
    } else {
        cookieString += "; path=/";
    }

    // Handle domain
    if (options.domain) {
        cookieString += "; domain=" + options.domain;
    }

    // Handle sameSite
    if (options.sameSite) {
        cookieString += "; SameSite=" + options.sameSite;
    }

    document.cookie = cookieString;
};
// Add removeCookie function
window.removeCookie = function (e) {
    document.cookie = e + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
